<script lang="ts">
    // 基本は MouseEnterTipsViewUtil によって、表示を操作するが、balloon自体にカーソルを置いた時の表示操作に利用
    import {MouseEnterTipsViewUtil} from "./MouseEnterTipsViewUtil";
    import {onMount} from "svelte";

    // 実際は不要だが rollup.js にて show の css が削除されているため、設定しておくことで消されないようにしている
    let isShowDummy = false;

    onMount(() => {
        // ブラウザ外にマウスが出ていくとBalloonを消す
        document.addEventListener('mouseleave', (event) => {
            MouseEnterTipsViewUtil.hideBalloon();
        });
    });

    function onMouseEnter() {

        MouseEnterTipsViewUtil.showBalloon();

    }

    function onMouseMove() {
        MouseEnterTipsViewUtil.showBalloon();


    }

    function onMouseLeave() {
        MouseEnterTipsViewUtil.hideBalloon();
    }

    function onClickText() {
        MouseEnterTipsViewUtil.hideBalloon();
    }

</script>


<div id="mouse-enter-tips-view"
     class:show={isShowDummy}

     on:mouseenter={onMouseEnter}
     on:mouseleave={onMouseLeave}
     on:mousemove={onMouseMove}
>
    <span class="text" on:click={onClickText}></span>


    <div class="arrow border"></div>
    <div class="arrow"></div>
</div>

<style lang="scss">
    #mouse-enter-tips-view {
        z-index: var(--mouse-enter-tips-view-z-index);

        font-size: 13px;

        position: absolute;
        border-width: 1px;
        border-style: solid;
        border-radius: 12px;
        top: 300px;
        left: 300px;
        padding-top: 0.25em;
        padding-bottom: 0.25em;
        padding-left: 1em;
        padding-right: 1em;
        background-color: var(--mouse-tips-background-color);
        color: var(--mouse-tips-text-color);

        opacity: 0;

        transition: opacity 0.25s;
        //transition-duration: 0.25s;

        pointer-events: none;
        filter: drop-shadow(2px 4px 6px #0006);

        .text {
            white-space: pre-wrap;
        }

        &.show {
            opacity: 1;
            transition-duration: 0.25s;
            pointer-events: all;
        }

        .arrow {
            border-style: solid;
            position: absolute;
            top: -5px;
            left: 0px;
            border-left-width: 10px;
            border-top-width: 0px;
            border-bottom-width: 5px;
            border-right-width: 10px;
            border-top-color: transparent;
            border-left-color: transparent;
            border-bottom-color: var(--mouse-tips-background-color);
            border-right-color: transparent;

            &.border {
                border-bottom-color: var(--mouse-tips-text-color);
                border-left-width: 12px;
                border-top-width: 0px;
                border-bottom-width: 6px;
                border-right-width: 12px;
                top: -6px;
                transform: translateX(-2px);

            }
        }
    }
</style>